import type { WorldCupForecastState, WorldCupMatchId } from '@wc26-forecast/model/types';

export function clearNextMatchResults(
  state: WorldCupForecastState,
  changedMatchId: WorldCupMatchId,
) {
  const affectedMatchIds = new Set<WorldCupMatchId>([ changedMatchId ]);
  let hasChanges = true;
  while (hasChanges) {
    hasChanges = false;
    state.matches.ids.forEach((matchId) => {
      if (affectedMatchIds.has(matchId)) {
        return;
      }
      const match = state.matches.byId[matchId];
      if (!match) {
        return;
      }
      const homeDependsOnChangedMatch =
        (
          match.homeSource.type === 'MATCH_WINNER' ||
          match.homeSource.type === 'MATCH_LOSER'
        ) &&
        affectedMatchIds.has(match.homeSource.matchId);
      const awayDependsOnChangedMatch =
        (
          match.awaySource.type === 'MATCH_WINNER' ||
          match.awaySource.type === 'MATCH_LOSER'
        ) &&
        affectedMatchIds.has(match.awaySource.matchId);
      if (!homeDependsOnChangedMatch && !awayDependsOnChangedMatch) {
        return;
      }
      affectedMatchIds.add(matchId);
      delete state.prediction.matchResults[matchId];
      if (match.round === 'FINAL') {
        state.prediction.finalScorePrediction = {
          homeScore: null,
          awayScore: null,
        };
      }
      hasChanges = true;
    });
  }
}
